import { render, staticRenderFns } from "./fio.vue?vue&type=template&id=3849da60&scoped=true"
import script from "./fio.vue?vue&type=script&lang=js"
export * from "./fio.vue?vue&type=script&lang=js"
import style0 from "./fio.vue?vue&type=style&index=0&id=3849da60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849da60",
  null
  
)

export default component.exports